import React, { Component } from 'react';

import { List, Card, Button } from "antd";
import {
  Link,
} from 'react-router-dom'

const data = [
  {
    title: 'Events',
    link: ``
  },
  {
    title: 'Projects',
    link: ``
  },
];

class Dashboard extends Component {

  render() {
    return (
      <div>
        <h1>Dashboard</h1>
        <Card className="dash" title='Events'>
          <Button type="primary" size="large" ><Link to='/dashboard/events/'>Manage Events</Link></Button>
        </Card>
        <Card className="dash" title='Projects'>
          <Button type="primary" size="large" ><Link to='/dashboard/projects/'>Manage Projects</Link></Button>
        </Card>
      </div>
    );

  }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard.js